import { Box, Stack } from '@mui/material';
import { useState } from 'react';

import { TourTravel } from '@/domain/project-tour-ontour/entities/project-tour-ontour-travel.entity';
import ArrowOutcomingLeft from '@/ui/assets/arrow-outcoming-left.svg';
import ArrowOutcomingRight from '@/ui/assets/arrow-outcoming-right.svg';

import { FavoriteTravelGroupOption } from '../../utils/tour-travel-favorite-group';
import { ModalTourTravelGroupForm } from '../tour-travel-view/ModalTourTravelGroupForm';
import { CityLabel } from './CityLabel';
import { TourTraveListOutcomingEmpty } from './TourTraveListOutcomingEmpty';
import { TourTravelItem } from './TourTravelItem';

export function TourTraveListOutcoming({
  tourTravels,
  onClickDelete,
  onClickAdd,
  favoriteIds,
  onToggleFavorite,
  favoriteTravels,
  onCopyTravel,
  isWindowFavorite,
  onToggleWindowFavorite,
  favoriteGroups,
  onCopyGroup,
}: {
  tourTravels: TourTravel[];
  onClickDelete: (tourTravelId: number) => void;
  onClickAdd: () => void;
  favoriteIds: Set<number>;
  onToggleFavorite: (id: number) => void;
  favoriteTravels: TourTravel[];
  onCopyTravel: (sourceTourTravel: TourTravel) => void;
  isWindowFavorite: boolean;
  onToggleWindowFavorite: () => void;
  favoriteGroups: FavoriteTravelGroupOption[];
  onCopyGroup: (travels: TourTravel[]) => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTravelIndex, setActiveTravelIndex] = useState(0);

  const onClickOpen = (index: number) => {
    setActiveTravelIndex(index);
    setModalOpen(true);
  };

  if (tourTravels.length === 0) {
    return <TourTraveListOutcomingEmpty />;
  }

  return (
    <>
      <ModalTourTravelGroupForm
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        tourTravels={tourTravels}
        initialIndex={activeTravelIndex}
        onClickAdd={onClickAdd}
        onDelete={onClickDelete}
        favoriteIds={favoriteIds}
        onToggleFavorite={onToggleFavorite}
        favoriteTravels={favoriteTravels}
        onCopyTravel={onCopyTravel}
        isWindowFavorite={isWindowFavorite}
        onToggleWindowFavorite={onToggleWindowFavorite}
        favoriteGroups={favoriteGroups}
        onCopyGroup={onCopyGroup}
      />
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 0 }}>
        <Box sx={{ ml: -0.5, position: 'relative', top: -1.5 }}>
          <img src={ArrowOutcomingLeft} />
        </Box>
        <Stack sx={{ alignItems: 'center', gap: 0 }}>
          {tourTravels.map((tourTravel, index) => (
            <Box key={tourTravel.id}>
              <Stack
                sx={{ flexDirection: 'row', alignItems: 'center', gap: 0 }}
              >
                <TourTravelItem
                  tourTravel={tourTravel}
                  onClickDelete={onClickDelete}
                  onClickOpen={() => onClickOpen(index)}
                  isFavorite={favoriteIds.has(tourTravel.id)}
                />
                <Box sx={{ ml: -0.5 }}>
                  <img src={ArrowOutcomingRight} />
                </Box>
                <CityLabel tourTravel={tourTravel} />
              </Stack>
            </Box>
          ))}
        </Stack>
      </Stack>
    </>
  );
}
